import script from "./regFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./regFooter.vue?vue&type=script&setup=true&lang=js"

import "./regFooter.vue?vue&type=style&index=0&id=74add3bf&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74add3bf"]])

export default __exports__